export const updateReducer = <T>(prev: T, newState: Partial<T>) => ({ ...prev, ...newState });
